
define(
	'Tavano.TT_ShowMoneySaved.ShowMoneySavedModule'
	, [
		'underscore'
	]
	, function (
		_
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				var layout = container.getComponent('Layout');
				var pdp = container.getComponent('PDP');

				if (layout) {

					// layout.addToViewContextDefinition('GlobalViews.Message.View', 'message', 'string', function (context) {
					// 	debugger
					// 	if(context.message == "Transaction Normal"){
					// 		context.message = "Error with Credit Card Authorization. Please verify.";
					// 	}

					// 	return context.message;
					// });

					layout.addToViewContextDefinition('ProductViews.Price.View', 'saveMoney', 'string', function (context) {
						
						var price = 0;
						var comparePrice = 0;
						var savedMoney = 0
						var porcentageSaved = 0;
						var savedMessage = "";

						// Get Matrix Information 
						var itemInfo = pdp.getItemInfo();
						var matrixInfo = pdp.getSelectedMatrixChilds();
						var matrixItemSelected = !_.isEmpty(itemInfo) && (!_.isEmpty(matrixInfo) && matrixInfo.length == 1);
						
						if (context.showComparePrice && context.comparePriceFormatted != "") {

							// Logic for Matrix Item with Selected Option
							if (matrixItemSelected) {

								price = matrixInfo[0].onlinecustomerprice || matrixInfo[0].keyMapping_price;
								comparePrice =  matrixInfo[0].pricelevel1;
								savedMoney = parseFloat(comparePrice) - parseFloat(price);
								porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(comparePrice));
								savedMessage = "Save $" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
							
							} else {

								price = context.price;
								if (context.model.item) {
									comparePrice = context.model.item.pricelevel1
								} else {
									comparePrice = context.model.pricelevel1;
								}
								savedMoney = parseFloat(comparePrice) - parseFloat(price);
								porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(comparePrice));
								savedMessage = "Save $" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
							
							}
						}

						return savedMessage;

					});

					layout.addToViewContextDefinition('Transaction.Line.Views.Price.View', 'saveMoney', 'string', function (context) {
						var price = 0;
						var comparePrice = 0;
						var savedMoney = 0
						var porcentageSaved = 0;
						var savedMessage = "";

						if (context.showComparePrice && context.comparePriceFormatted != "") {
							price = context.price;
							if (context.model.item) {
								comparePrice = context.model.item.pricelevel1
							} else {
								comparePrice = context.model.pricelevel1;
							}
							savedMoney = parseFloat(comparePrice) - parseFloat(price);
							porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(comparePrice));
							savedMessage = "Save $" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
						}

						return savedMessage;

					});

					layout.addToViewContextDefinition('Header.MiniCartItemCell.View', 'saveMoney', 'string', function (context) {
						var price = 0;
						var comparePrice = 0;
						var savedMoney = 0
						var porcentageSaved = 0;
						var savedMessage = "";

						if (context.showComparePrice && context.comparePriceFormatted != "") {

							if (context.line.item) {
								price = context.line.rate;
								comparePrice = context.line.item.pricelevel1
							}

							savedMoney = parseFloat(comparePrice) - parseFloat(price);
							porcentageSaved = (parseFloat(savedMoney) * 100 / parseFloat(comparePrice));
							savedMessage = "Save $" + parseFloat(savedMoney).toFixed(2) + " (" + parseInt(porcentageSaved) + "%)";
						}

						return savedMessage;

					});

				}


			}
		};
	});
